import React from "react";
import { useHistory } from "react-router-dom";
import {
  ActivityIcon,
  BarChartIcon,
  CheckSquareIcon,
  DatabaseIcon,
  DescriptionCard,
  ExternalLinkIcon,
  FlaskIcon,
  Grid,
  PackageIcon,
  RadioIcon,
  Section,
  SlidersIcon,
} from "@KristianIV/common-ui";

interface Tool {
  title: string;
  description: string;
  icon: React.ReactNode;
  /** In-app route. */
  to?: string;
  /** External site, opened in this tab as before. */
  href?: string;
}

const OPERATIONS: Tool[] = [
  { title: "Modes", description: "The operating modes and the organisations using them.", icon: <SlidersIcon />, to: "/modes" },
  {
    title: "Potential incident live view",
    description: "Live view of potential incidents across all organisations and devices.",
    icon: <RadioIcon />,
    to: "/incidentPlayer",
  },
  { title: "App versions", description: "Which app versions the scouts are running.", icon: <PackageIcon />, to: "/scoutVersions" },
];

const dataProcessing = (jwtToken: string): Tool[] => [
  { title: "Config store", description: "Edit system properties.", icon: <DatabaseIcon />, to: "/configStore" },
  { title: "Monitor", description: "Monitor the system.", icon: <ActivityIcon />, to: "/monitor" },
  { title: "Learning", description: "Where we test our classifiers.", icon: <FlaskIcon />, href: "https://triangula-learning.web.app/#/" },
  {
    title: "Dataset label verification",
    description: "Verify the labels of our dataset.",
    icon: <CheckSquareIcon />,
    href: `https://dataset-label-verification.triangula.com/?token=${jwtToken}`,
  },
  { title: "Raw data analysis", description: "Metrics for our raw audio data.", icon: <BarChartIcon />, to: "/rawDataAnalytics" },
];

const ToolGrid = ({ title, tools }: { title: string; tools: Tool[] }) => {
  const history = useHistory();
  return (
    <Section title={title}>
      <Grid>
        {tools.map((tool) => (
          <DescriptionCard
            key={tool.title}
            title={tool.title}
            description={tool.description}
            icon={tool.icon}
            trailing={tool.href ? <ExternalLinkIcon /> : undefined}
            onClick={() => (tool.href ? window.location.assign(tool.href) : history.push(tool.to!))}
          />
        ))}
      </Grid>
    </Section>
  );
};

/** The links to the other admin pages and the external tools, grouped as before. */
const ToolCards = ({ jwtToken }: { jwtToken: string }) => (
  <>
    <ToolGrid title="Operations" tools={OPERATIONS} />
    <ToolGrid title="Data processing" tools={dataProcessing(jwtToken)} />
  </>
);

export default ToolCards;
